import {
    UPLOAD_FILE_BEGIN,
    UPLOAD_FILE_SUCCESS,
    UPLOAD_FILE_FAILURE,
    KEY_FOR_TOPIC_ID,
    KEY_FOR_FILE_NAME,
    KEY_FOR_FILE_LANGUAGE,
    KEY_FOR_FILE_DATE_UPLOADED,
    KEY_FOR_UPLOADED_FILE,
    KEY_FOR_DATE_FOR_COMMENTS
  } from './constants';
  import http from '../../../common/http';
  import { apiEndPoints } from '../../../common/globalConstants';
  
  export function uploadFile(props = {}) {
    return dispatch => {
      dispatch({
        type: UPLOAD_FILE_BEGIN,
      });
      const url = `${apiEndPoints.uploadFile.UPLOAD_FILE}`;
      const promise = new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append(KEY_FOR_TOPIC_ID, props.topicId);
        formData.append(KEY_FOR_FILE_NAME, props.uploadedFile.name);
        formData.append(KEY_FOR_FILE_LANGUAGE, props.language);
        formData.append(KEY_FOR_FILE_DATE_UPLOADED, props.dateUploaded);
        formData.append(KEY_FOR_UPLOADED_FILE, props.uploadedFile);
        if (props.dateForComments) { 
          formData.append(KEY_FOR_DATE_FOR_COMMENTS, props.dateForComments);
        }

        const doRequest = http.post(url,formData);
        doRequest.then(
          res => {
            dispatch({
              type: UPLOAD_FILE_SUCCESS,
              data: res.data,
            });
            resolve(res);
          },
          err => {
            dispatch({
              type: UPLOAD_FILE_FAILURE,
            });
            reject(err);
          },
        );
      });
  
      return promise;
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case UPLOAD_FILE_BEGIN:
        return {
          ...state,
          createTopicsSuccess: false,
          uploadFileBegin:     true,
          uploadFileFailure:   false,
          uploadFileSuccess:   false
        };
      case UPLOAD_FILE_SUCCESS:
        return {
          ...state,
          uploadFileBegin: false,
          uploadFileSuccess: true
        };
      case UPLOAD_FILE_FAILURE:
        return {
          ...state,
          uploadFileBegin: false,
          uploadFileFailure: true,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/topics/redux/uploadFile.js